import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Constants } from 'src/app/shared/utils/constants';

@Component({
  selector: 'app-spray-drift-options',
  templateUrl: './spray-drift-options.component.html',
  styleUrls: ['./spray-drift-options.component.css']
})
export class SprayDriftOptionsRenderer implements ICellRendererAngularComp {

  SPRAY_DRIFT_OPTIONS = [
    { name: 'Use FOCUS(Step3) mass loading', key: 'SDO_01' },
    { name: 'Select buffer width', key: 'SDO_02' },
    { name: 'Enter mass loading directly', key: 'SDO_03' },
  ];
  selectedOption: any = {};
  checkbox: boolean = true;
  multiple: boolean = false;
  params: any;
  parent: any;
  disabled: any;

  agInit(params: any): void {
    this.params = params;
    this.parent = params.context;
    this.disabled = params.disabled ?? false;
    this.selectedOption = this.SPRAY_DRIFT_OPTIONS.find(x => x.key === params.value);
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

  onChange(event: any) {
    this.selectedOption = event.value;
    if (event)
      this.parent.sprayDriftOptionSelectionChanged({
        field: 'sprayDriftOption',
        id: this.params.node.id,
        value: this.selectedOption,
        row: this.params.data
      });
  }

}
